export default "/images/77b844b0f021eaf2eb98df83d3629260.png";